// TOUR-4b — Opportunities mode entry tour (product-agnostic).
// Colloquial phrases like "red iron proposal" are intent aliases only — the
// tour targets the Opportunity Engine in Opportunities mode, not a product line.

import type { FireflyTourArtifact } from "../tourTypes";

export const OPPORTUNITIES_ENTRY_TOUR_ID = "tour-opportunities-entry";

export const OPPORTUNITIES_ENTRY_TOUR: FireflyTourArtifact = {
  id: OPPORTUNITIES_ENTRY_TOUR_ID,
  version: 1,
  defaultIntent: "teaching",
  intents: [
    "how do i start a proposal",
    "how do i start a red iron proposal",
    "start a proposal",
    "red iron proposal",
    "new opportunity",
    "create an opportunity",
    "opportunities tour",
    "how do i use opportunities",
    "start a deal",
  ],
  bucketRelevance: ["sales"],
  requiredRoles: ["sales"],
  steps: [
    {
      id: "nav-opportunities",
      target: { mode: "leads", anchorId: "mode-nav-opportunities", scrollIntoView: true },
      deferModeNavigation: true,
      skipWhenCurrentMode: "opportunities",
      copy: {
        title: "Open Opportunities",
        body: "Deals and proposal packages live in Opportunities — tap it in the sidebar (or bottom bar on mobile) to switch modes.",
      },
      waitForClick: true,
    },
    {
      id: "new-opportunity",
      target: { mode: "opportunities", anchorId: "opp-new-opportunity", scrollIntoView: true },
      copy: {
        title: "Create an opportunity",
        body: "Tap + New opportunity when you are ready to start a deal. You pick the product type inside the form — Red Iron is one format, not a separate app area.",
      },
      destructive: true,
    },
    {
      id: "opp-list",
      target: { mode: "opportunities", anchorId: "opp-list-surface", scrollIntoView: true },
      copy: {
        title: "Your pipeline",
        body: "Saved opportunities appear in this list. Open one to add pricing, documents, and generate a proposal PDF when you are ready.",
      },
      advanceOn: "next_button",
    },
    {
      id: "ask-firefly",
      target: { mode: "opportunities", anchorId: "ask-firefly", scrollIntoView: true },
      copy: {
        title: "Ask Firefly anytime",
        body: "Stuck on the next step? Expand Firefly and use Ask Firefly — tours can start from any Sales mode.",
      },
      advanceOn: "next_button",
    },
  ],
};
